import React from 'react';
import { formatFieldName } from '../../utils/formatters';

const LongTextAnswersSection = ({ longTextAnswers }) => {
    if (longTextAnswers.length === 0) {
        return null;
    }

    return (
        <div style={{ marginBottom: '30px' }}>
            {longTextAnswers.map(([field, value]) => (
                <div 
                    key={field}
                    style={{
                        backgroundColor: '#2d2d2d',
                        border: '1px solid #404040',
                        borderRadius: '6px',
                        padding: '20px',
                        marginBottom: '20px'
                    }}
                >
                    <h4 style={{
                        margin: '0 0 12px 0',
                        color: '#e0e0e0',
                        fontWeight: '600'
                    }}>
                        {formatFieldName(field)}
                    </h4>
                    <p style={{
                        margin: 0,
                        color: '#d0d0d0',
                        lineHeight: '1.6',
                        fontSize: '14px'
                    }}>
                        {value}
                    </p>
                </div>
            ))}
        </div>
    );
};

export default LongTextAnswersSection;






